import { AppUser } from 'Src/views/App/App';
import axios from 'Src/helpers/api/axiosInstance';
import { normalizeGeneralMessageAttachmentSizeLimit } from 'Src/helpers/generalMessageAttachments/generalMessageAttachmentSize';

export function getSettingsUploadFiles(user: AppUser): Promise<number> {
  const { roleSessionKey: key } = user;

  const config = {
    headers: { usid: key }
  };

  return axios
    .get(`${window.apiBase}/i/settings`, config)
    .then(response => normalizeGeneralMessageAttachmentSizeLimit(response.data))
    .catch(() => normalizeGeneralMessageAttachmentSizeLimit(undefined));
}
